import React from 'react';
import $ from 'jquery';
import '../../reveal_modal/jquery-reveal-modal';

import FormRenderer from './formRenderer';

export function FormModal({ id, article, position }) {
  // return a modal wrapper with a form inside.
  return (
    <div className="reveal-modal reveal-modal-white reveal-modal-scroll" id={id}>
      <div className="form-modal">{FormRenderer.displayFor(article, position)}</div>
      <a className="close-reveal-modal">&#215;</a>
    </div>
  );
}

FormModal.propTypes = {
  id: React.PropTypes.string,
  article: React.PropTypes.object,
  position: React.PropTypes.string
};

export function FormModalButton({ id, buttonText }) {
  // register form modal on button click
  $(`[data-reveal-id="${id}"]`).on('click', (e) => {
    e.stopPropagation();
    e.preventDefault();

    const $reveal = $(`#${id}`);

    $reveal.reveal();
  });

  // prevent scrolling body when opening a form modal.
  // there should be a scroll only inside the modal.
  $(document).on('reveal:open', function () {
    $('body').addClass('no-scroll');
  });

  // revert preventing scrolling body when closing a form modal.
  $(document).on('reveal:close', function () {
    $('body').removeClass('no-scroll');
  });

  // return the button that triggers the form modal.
  return (
    <div>
      <a href="#" title={buttonText} className="button button-invert" data-reveal-id={id}>
        {buttonText}
      </a>
    </div>
  );
}

FormModalButton.propTypes = {
  id: React.PropTypes.string,
  buttonText: React.PropTypes.string
};



// WEBPACK FOOTER //
// ./components/forms/FormModal.js